import React from "react";
import Hcv from "../../Artifacts/HCV.svg";
import ILMCV from "../../Artifacts/ILMCV.svg";
import SCVPU from "../../Artifacts/SCV.svg";
import CV from "../../Artifacts/CV.svg";

const TqpCard = ({ heading, data }) => {
  const gradients = {
    "HCV Trucks": "from-[#FFE700] to-[#F9A526]",
    "ILMCV Trucks": "from-[#3CD0C0] to-[#129BD2]",
    "SCV & PU": "from-[#EF6AE9] to-[#8463FA]",
    "CV Passenger": "from-[#FE875D] to-[#FD4D90]",
  };

  const image = {
    "HCV Trucks": Hcv,
    "ILMCV Trucks": ILMCV,
    "SCV & PU": SCVPU,
    "CV Passenger": CV,
  };

  const cards = Object.entries(data || {}).map(([label, value]) => ({
    label,
    value,
    gradient: gradients[label] || "from-gray-300 to-gray-500", // Default gradient for unknown labels
    image: image[label],
  }));

  return (
    <div className="bg-white rounded-md p-2">
      <div className="text-center mb-2  text-[#484848] font-semibold">
        {heading}
      </div>
      <div className="flex flex-col gap-2">
        {cards.map((card, index) => (
          <div
            key={index}
            className={`bg-gradient-to-b ${card.gradient} rounded-md  px-4 py-2 text-center flex items-center justify-between gap-2 whitespace-nowrap text-white font-bold`}
          >
            <img src={card.image} alt={card.label} className=" " />
            {card.label} <span className="font-bold">{card.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TqpCard;
